import { verseOfTheDay } from "@/lib/scripture";
import { Cross } from "lucide-react";
import { motion } from "framer-motion";

// tone: "parent" (terracotta) | "student" (sage) | "light" (on dark hero)
export function VerseBanner({ tone = "parent" }) {
  const v = verseOfTheDay();
  const bg = tone === "student" ? "#81B29A" : "#E07A5F";
  return (
    <motion.div
      data-testid="verse-of-the-day"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-2xl p-5 md:p-6 text-white grain"
      style={{ background: bg }}
    >
      <div className="flex items-start gap-4">
        <span className="grid place-items-center w-10 h-10 rounded-full bg-white/20 shrink-0">
          <Cross size={18} />
        </span>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-white/80">Verse of the Day</p>
          <p className="font-head text-lg md:text-xl leading-snug mt-1">"{v.text}"</p>
          <p className="stat text-sm text-white/85 mt-1">— {v.ref}</p>
        </div>
      </div>
    </motion.div>
  );
}
